import { FormattedMessage } from 'react-intl';
import { Alert } from '@mui/material';

import useSettings from '../hooks/useSettings';

import AudioViewer from './drivers/AudioViewer';
import CsvViewer from './drivers/CsvViewer';
import DocxViewer from './drivers/DocxViewer';
import ImageViewer from './drivers/ImageViewer';
import MsgViewer from './drivers/MsgViewer';
import PdfViewer from './drivers/PdfViewer';
import SvgViewer from './drivers/SvgViewer';
import TxtViewer from './drivers/TxtViewer';
import VideoViewer from './drivers/VideoViewer';
import XlsxViewer from './drivers/XlsxViewer';

export interface FilesViewerProps {
	/** The component className */
	className?: string;
	/** The file path on server */
	filePath: string;
	/** The file encoded in base64 */
	fileEncoded: string;
	/** The file type based on extension */
	fileType: string;
}

function getViewer(fileType) {
	switch (fileType) {
		case 'jpg':
		case 'jpeg':
		case 'gif':
		case 'bmp':
		case 'png':
			return ImageViewer;
		case 'svg':
			return SvgViewer;
		case 'txt':
			return TxtViewer;
		case 'pdf':
			return PdfViewer;
		// TODO: implementare un parser per file .doc
		// case 'doc':
		case 'docx':
			return DocxViewer;
		case 'csv':
			return CsvViewer;
		case 'xls':
		case 'xlsx':
		case 'xlsm':
			return XlsxViewer;
		case 'msg':
		case 'eml':
			return MsgViewer;
		case 'webm':
		case 'mp4':
			return VideoViewer;
		case 'mp3':
			return AudioViewer;
		default:
			return undefined;
	}
}

/** File explorer component */
export default function FilesViewer({ filePath, fileEncoded, fileType }: FilesViewerProps) {
	const { t } = useSettings();

	const Viewer = getViewer(fileType);

	return Viewer ? (
		<Viewer filePath={filePath} fileEncoded={fileEncoded} fileType={fileType} />
	) : (
		<Alert severity="warning">
			<FormattedMessage
				id="fileViewer.notSupported"
				defaultMessage={t('FILE_VIEWER_NOT_SUPPORTED')}
				values={{ fileType: <b>{fileType}</b> }}
			/>
		</Alert>
	);
}
